
import { Component, Mixins } from "vue-property-decorator";
import { CreateElement } from "vue";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component
export default class CProdConditionNotif extends Mixins(CProdInjectorMixin) {
  public render(h: CreateElement) {
    if (!this.cProdData.condition) return;
    const { type, description, action } = this.cProdData.condition;
    return h("div", { staticClass: "u-cpcn-wrapper", class: type }, [
      h("div", { staticClass: "u-cpcn-content" }, [
        h("p", { staticClass: "has-margin-right-auto" }, [h(description)]),
        action && h("div", { staticClass: "u-cpcn-action" }, [action(h)])
      ])
    ]);
  }
}
